export default __webpack_public_path__ + "static/media/active_pound.a64b7315.png";